import { UserStatus } from "@generated/CurrentUser_Query.graphql";

export const selectTooltipBasedOnGlobalUserStatus = (status: UserStatus | undefined) => {
	switch (status) {
		case "doccheck":
			return "Das Modul kann von DocCheck-Nutzern nicht bearbeitet werden. Bitte registrieren Sie sich bei InfectoPharm oder melden Sie sich mit ihrem bestehenden Benutzerkonto an.";
		case "noProcess":
			return "Ihr Konto ist nicht vollständig freigeschaltet.";
		case "efnNeeded":
			return "Damit Sie dieses Modul bearbeiten können benötigen wir Ihre EFN/ÖÄK. Bitte tragen Sie Ihre EFN/ÖÄK in Ihrem Benutzerprofil ein.";
		case "initialValidation":
			return "Ihr Konto ist nicht vollständig freigeschaltet.";
		case "changeInProgress":
			return "Ihre Daten befinden sich aktuell im Überprüfungsprozess. Dies kann bis zu einer Woche dauern.";
		default:
			return "Dieser Service steht Ihnen nicht zur Verfügung.";
	}
};
